define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/_base/underscore",
	"csi/action/Controller",
	"csi/comm",
	"csi/locale",
	"csi/wizard/ActionControllerMixin",
	"csi/xml",
	"csi/xml/Query",
	"Specification",
	"./MassAddMaterialForm"
], function(declare,lang,_,Controller,comm,locale,ActionControllerMixin,xml,Query,Specification) {
	
	const DSSECTION = "DSSection";
	const PRODUCT_TYPE = "ProductType";
	
	return declare([Controller, ActionControllerMixin], {
		_queryPath:"Child:__Parent__/Child:__Parent__",
		_subtypeSettingsPath: "Child:__Parent__/Child:__Parent__/Child:__Parent__/Child:Subtype/Child:Settings",
		_classController:"MaterialSpecProductSpec/MassAddMaterialForm",
		_operationMaterialBOM: "BOMCreatePartMaterialFromMaterial",
		_operationFoodBOM: "FoodBOMCreateBOMLineItemFromMaterial",

		successMsg: "",

		/**
		 * @param fd 
		 * @returns list of ProductBOMRevisions of selected placements
		 */
		getSelectedValues(fd) {
			return fd.getSelectedValue();
		},

		getFormData: function() {
			// summary: make sure that at least one PartMaterial is selected
			var	fd = this.inherited(arguments);
			fd.m_bRequireOne = true;
			fd.m_fAggregateTest = lang.hitch(this, this._canAggregateNode);

			var node = this.m_cache.getNode(Specification.URL_ADMIN);
			if (node && node.Placements.length) {
				fd.HasPlacements = true;
			}

			return fd;
		},

		getWizardViewQuery: function(/*csi.wizard.Widget*/wizard, /*csi.view.Widget*/view, /*Number*/index) {
			// summary: return query for BOM-lines view
			var	q;

			if(index == 0) {
				this._isApparelBOMAction = view._isApparelBOMAction;
				this._isFoodBOMAction = view._isFoodBOMAction;
				this._isThemeBOMAction = view._isThemeBOMAction;
				if (this._isApparelBOMAction || this._isThemeBOMAction) {
					this._fieldFilter = view.FIELD_SEASON;
				} else if (this._isFoodBOMAction) {
					this._fieldFilter = view.FIELD_TARGET_FOOD_TYPE;
				} else {
					this._fieldFilter = view.FIELD_TARGET_MATERIAL_TYPE;
				}
			} else if (index == 1) {
				// table view of all BOMs (revisions) that the current revision is in Draft state, and satisfy the filter
				var filter = this.m_formData.getFieldValue(this._fieldFilter);
				let filterFieldName;
				if (this._isApparelBOMAction) {
					filterFieldName = "ParentSeason";
				} else if (this._isFoodBOMAction) {
					filterFieldName = "Subtype";
				} else if (this._isThemeBOMAction){
					filterFieldName = "ThemeSeasons";
				} else {
					filterFieldName = "ProductType";
				}

				q = new Query();
				if (this._isThemeBOMAction) {
					q.Or().Attr("ThemeToSeason", xml.OP_EQUALS, "ThemeToSeason:AllSeasons", this._subtypeSettingsPath)
						.RefAttr(filterFieldName, xml.OP_EQUALS, filter, this._queryPath);
				} else {
					q.RefAttr(filterFieldName, xml.OP_EQUALS, filter, this._queryPath);
				}
				q.Not().RefAttr("BOMMaterials", xml.OP_EQUALS, this.m_urlParent);

				// C8FB-631: If action invoked from WhereUsedFoodBOM, only show Food BOMs that allow Material as placement type
				if (this._isFoodBOMAction) {
					const productTypeEnum = xml.enumCreate(PRODUCT_TYPE, "Material");
					q.Attr("ItemsProductTypes", xml.OP_EQUALS, productTypeEnum, "Child:__Parent__/Child:Subtype/Child:Settings");
				}
			}

			return q;
		},

		onNextPage: function(/*csi.wizard.Widget*/wizard,
							 /*csi.wizard.Content*/currentPage,
							 /*csi.wizard.Content*/nextPage,
							 /*Boolean*/bFinish) {
			// summary: prepare the data and pass it into the next page
			return bFinish ? null : wizard.setFormDataToPage(nextPage, this.m_formData, (wizard.getIndexOfPage(nextPage) == 1));
		},

		onWizardViewPreCreate: function(/*csi.wizard.Widget*/wizard, /*Content*/page, /*View*/defView, /*Object*/viewParams) {
			// summary: notify when view definition for page is found and ready for creation with ability to add own viewParams
			var index = wizard.getIndexOfPage(page);
			if (index == 0) {
				defView.classController = this._classController;
			}
		},

		onWizardViewCreate: function(/*csi.wizard.Widget*/wizard, /*Content*/page, /*csi.view.Widget*/view) {
			// summary: notify when view created for page
			var index = wizard.getIndexOfPage(page);
			if (index == 0) {
				view.addFixedValue(view.FIELD_MATERIAL_NAME, this.getParent().$Name);
			}
		},
		
		/**
		 * @override
		 * Calculate number of successful nodes created for success message once response is returned
		 * instead of retrieving directly from response, since this action uses a batch operation instead
		 * of a single operation that processes nodes en-masse.
		 */
		postProcessSuccess: function() {
			// Return response with number of successfully created nodes
			const nodes = this.m_response.getNodes();
			const type = this._isFoodBOMAction ? "FoodBOMLineItem" : "PartMaterial";
			let numCreated = 0;
			if (this._isThemeBOMAction) {
				numCreated = nodes.length;
			} else {
				_.forEach(nodes, function(node) {
					if (node.$Type === type) {
						numCreated++;
					}
				});
			}

			let resource;
			if (this._isThemeBOMAction) {
				resource = numCreated === 1 ? "MassAddThemeBOM_Success" : "MassAddThemeBOMs_Success";
			} else {
				resource = this._isFoodBOMAction ? "MassAdd_Success" : "";
			}
			this.successMsg = locale.resource(resource, [numCreated]);
			return this.inherited(arguments);
		},

		/**
		 * @override
		 */
		getSuccess: function() {
			return this.successMsg;
		},

		toWriter: function() {
			// TA28975: Optimize operation for high number of placements. Use only 1 batch operation
			// call operation for all selected nodes
			var	fd = this.m_formData;
			const operation = (this._isFoodBOMAction) ? this._operationFoodBOM : this._operationMaterialBOM;
			const reqModule = (this._isFoodBOMAction) ? "FormulatedProduct" : "Specification";
			const callList = this.m_writer.callList(reqModule, operation, this.getSelectedValues(fd), xml.PROP_URL);
			callList.addParameter("FromURL", xml.ATTR_REF, this.m_urlParent);

			var dsSection = fd.getFieldValue("BomSection", true);
			if (dsSection) {
				callList.addParameter(DSSECTION, xml.ATTR_REF, dsSection);
			}

			_.forEach(fd.getFields(), function(field) {
				var fieldId = field.idParameter || field.m_id;
				if (fieldId && !field.m_bUsed) {
					callList.addGeneralizedParameter(fieldId, field.getType(), field.getValue());
					field.m_bUsed = true;
				}
			}, this);
		},
		
		_canAggregateNode: function(/*Context*/ctx, /*FormData*/fd) {
			// If the user does not have edit access on the BOM then it is displayed but is not selectable.
			return xml.nodeHasRight(ctx.getNode(), xml.RIGHT_WRITE);
		},

		_getContextApparelBOMRevisionNode: function(ctx){
			return ctx.getNode();
		},

		_preActionRequests: function(/*Request[]*/requests) {
			var request = comm.getNodeRequest(Specification.URL_ADMIN);
			if (request) {
				requests.push(request);
			}
		}

	});
});